export default __webpack_public_path__ + "static/media/x-mark.7a6ed2e6.svg";